import React, {createContext, useState, use} from "react";
import PropTypes from "prop-types";

const FeatureFlagContext = createContext({setFeatureFlags: () => {}});

export const FeatureFlagProvider = ({children}) => {
  const [featureFlags, setFeatureFlags] = useState({
    showDeveloper: process.env.DEVELOPER_FLAG === "true" || process.env.DEVELOPER_FLAG === true,
    showGettingStarted: true,
    showStaleDetectionWithoutLiveChanges: false,
    enableMaestroUiSidebar: process.env.ENVIRONMENT_NAME !== "production",
  });

  return (
    <FeatureFlagContext value={{...featureFlags, setFeatureFlags}}>{children}</FeatureFlagContext>
  );
};

FeatureFlagProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useFeatureFlags = () => {
  return use(FeatureFlagContext);
};
